import { render } from "./CustomAreaManagerPostcodes.vue?vue&type=template&id=6985818e&scoped=true"
import script from "./CustomAreaManagerPostcodes.vue?vue&type=script&lang=js"
export * from "./CustomAreaManagerPostcodes.vue?vue&type=script&lang=js"

import "./CustomAreaManagerPostcodes.vue?vue&type=style&index=0&id=6985818e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6985818e"]])

export default __exports__